import { IconButton, Tooltip, Divider, Button } from "@mzc-pdc/ui";
import { Typography } from "@mui/material";

const TooltipButton = ({
    title,
    buttonText,
    hidden,
    disabled = false,
    onClickButton,
    buttonIcon,
    isEndIcon = false,
    isDivided = false,
    isResponsive = true,
    color = "inherit",
    size = "medium",
    sx,
    placement,
    // 아래 두 곳 모두 값이 있을 때만 얹는다. aria-label={undefined} 로 넘기면 값이 없어도
    // children.props 에 키가 남아, Tooltip 이 title 로 주입한 이름을 덮어써
    // aria-label 을 주지 않은 사용처의 접근 가능한 이름이 사라진다(@mui/material@5 Tooltip.js:462-471).
    // 문자열 title 은 MUI 가 이미 이름으로 쓰므로 title 폴백은 두지 않는다.
    "aria-label": ariaLabel,
    ...props
}) => {
    return (
        <>
            {!hidden && (
                <>
                    {isResponsive ? (
                        <Tooltip title={title} placement={placement ?? "bottom"}>
                            <IconButton
                                {...(ariaLabel ? { "aria-label": ariaLabel } : {})}
                                circled={props?.circled}
                                disabled={disabled}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onClickButton();
                                }}
                                type="button"
                                variant={props?.variant ?? "text"}
                                size={size}
                                color={color}
                                sx={sx}
                            >
                                {buttonIcon}
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <Button
                            {...(isEndIcon ? { endIcon: buttonIcon } : { startIcon: buttonIcon })}
                            {...(ariaLabel ? { "aria-label": ariaLabel } : {})}
                            disabled={disabled}
                            variant={props?.variant ?? "text"}
                            size={size}
                            onClick={(e) => {
                                e.stopPropagation();
                                onClickButton();
                            }}
                            color={color}
                            sx={sx}
                        >
                            {buttonText && <Typography variant={"body1_400"}>{buttonText}</Typography>}
                        </Button>
                    )}
                    {isDivided && <Divider flexItem orientation={"vertical"} sx={{ my: 0.5, opacity: 0.12 }} />}
                </>
            )}
        </>
    );
};

export default TooltipButton;
